const messages = {
  currentTime: 'Current Time',
  warningNextSection: 'Warning – next section will Auto-Launch in',
  launchManually: 'You may launch manually before the timer expires',
};

export { messages };
